import { render, staticRenderFns } from "./Finalize-Count.vue?vue&type=template&id=fdded6a4&scoped=true&"
import script from "./Finalize-Count.vue?vue&type=script&lang=js&"
export * from "./Finalize-Count.vue?vue&type=script&lang=js&"
import style0 from "./Finalize-Count.vue?vue&type=style&index=0&id=fdded6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdded6a4",
  null
  
)

export default component.exports